<template>
  <BaseModal
    :open="show"
    @close="$emit('Saya Mengerti')"
    title="Ketentuan Privasi dan Keamanan"
    size="lg"
  >
    <!-- Modal content goes here -->
    <div class="space-y-4">
      <h1
        ref="agenda-preview-title"
        class="mb-4 text-xl font-medium leading-8 text-green-700 font-roboto"
        data-cy="agenda-preview__title"
      >
        Ketentuan Privasi Akun
      </h1>
      <p>Privacy anda penting bagi kami. Portal Jabar berkomitmen untuk melindungi data pribadi setiap pengguna.</p>
      <ul class="list-disc list-inside space-y-2">
        <strong>Data yang kami simpan :</strong>
        <li>Informasi Akun : nama, alamat email, jabatan, dan identitas pengguna yang digunakan untuk mengelola akses.</li>
        <li>Aktivitas Pengguna : riwayat login, perubahan konten, dan interaksi dengan sistem.</li>
        <li>Data pendukung lain yang relevan untuk meningkatkan layanan.</li>
      </ul>
      <ul class="list-disc list-inside space-y-2">
        <strong>Bagaimana data digunakan :</strong>
        <li>Menyediakan akses sesuai peran (Kontributor, Admin, Super Admin)</li>
        <li>Memastikan keamanan dan validasi identitas pengguna</li>
        <li>Mendukung peningkatan kualitas layanan Portal Jabar</li>
      </ul>
      <ul class="list-disc list-inside space-y-2">
        <strong>Hak anda sebagai pengguna : </strong>
        <li>Mengubah atau memperbaharui informasi akun</li>
        <li>Mengajukan permintaan penghapusan data sesuai prosedur</li>
        <li>Mendapatkan transparansi mengenai pengunaan data</li>
      </ul>
      <ul class="list-disc list-inside space-y-2">
        <strong>Keamanan data :</strong>
        <p>Kami menggunakan langkah pengamanan teknis dan administratif untuk menjaga kerahasiaan, integritas, dan ketersediaan data anda</p>
      </ul>
    </div>
    <template #footer>
      <div class="w-full h-full flex items-center justify-center">
        <BaseButton
            class="h-[38px] px-4 flex items-center rounded-lg border whitespace-nowrap font-bold disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-300 bg-green-700 hover:bg-green-600 text-sm text-white"
            data-cy="modal-footer__close-button"
            @click="$emit('close')"
          >
          Saya Mengerti
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/common/components/BaseModal';
import BaseButton from '@/common/components/BaseButton';

export default {
  name: 'PrivacyAndSecurityPreview',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>
